import React, { createContext, useContext, PropsWithChildren } from 'react';
import { useUser } from './UserContext';
import { useUserProfile } from './UserProfileContext';

const UserNameContext = createContext<string>('User');

export const UserNameProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const user = useUser();
  const { profile } = useUserProfile();

  const last = (profile?.lastName ?? '').trim();
  const first = (profile?.firstName ?? '').trim();
  const profileName = [last, first].filter(Boolean).join(' ');
  const fallback = user?.signInDetails?.loginId ?? 'User';
  const userName = profileName.length > 0 ? profileName : fallback;

  return (
    <UserNameContext.Provider value={userName}>
      {children}
    </UserNameContext.Provider>
  );
};

export const useUserName = () => useContext(UserNameContext);